import React,{ Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Container, Row, Col} from 'reactstrap';
import HeaderSection from './Header';
import PayAmountSection from './PayAmount';
import BankTransferSection from './BankTransfer';
import XenditSection from './Xendit';
import MidtransSection from './Midtrans';
import KredivoSection from './Kredivo';
import AkulakuSection from './Akulaku';
import AtomeSection from './Atome';

// const getTotal = ({offer_amount,unique_amount,administration_fee})=> (parseFloat(offer_amount)+parseFloat(unique_amount)+parseFloat(administration_fee)).toString()
export default class Invoice extends Component{
  render(){
    return(
      <Container className="invoice-container">
        <Row className="invoice-wrapper">
          <HeaderSection invoice_number={this.props.payment.invoice_number}/>
            {
              this.props.type==='kickwallet'? 
              null
              :
              <Col xs={12} md={12} className="section">
                <div className="header text-center">
                  <span>Please Pay:</span>
                  <PayAmountSection total={this.props.payment.total_adjusted_amount}/>
                </div>
              </Col>
            }
            <Col xs={12} md={12} className="invoice-body">
              {
                this.props.type==='transfer'?
                <BankTransferSection data={this.props.payment.account_banks} onClick={this.props.onActionClick} expire={this.props.payment.expiry}/>
                :
                this.props.type==='xendit'?
                <XenditSection data={this.props.payment} onClick={this.props.onActionClick} expire={this.props.payment.expiry}/>
                :
                this.props.type==='midtrans'?
                <MidtransSection
                  trxTkn={this.props.trxTkn}
                  data={this.props.payment}
                  onClick={this.props.onActionClick}
                  expire={this.props.payment.expiry}
                />
                :
                this.props.type==='kredivo'?
                <KredivoSection data={this.props.payment} onClick={this.props.onActionClick} expire={this.props.payment.expiry}/>
                :
                this.props.type==='akulaku'?
                  <AkulakuSection data={this.props.payment} onClick={this.props.onActionClick} expire={this.props.payment.expiry}/>
                :
                this.props.type==='atome'?
                  <AtomeSection data={this.props.payment} onClick={this.props.onActionClick} expire={this.props.payment.expiry}/>
                :
                null
              }
            </Col>
        </Row>
      </Container>
    )
  }
}